<template>
  <div class="pageFarm__onlyContent contentError">
    <img src="~img/errors/404.png" alt="Computer" class="contentError__img" />
    <p class="contentError__subtitle">{{ $t(`That’s all we know`) }}</p>
    <p class="contentError__title">
      404 <span class="textW--lightGray">{{ $t(`That’s an error`) }}</span>
    </p>
    <p class="contentError__text">
      {{ $t('The requested URL was not found on this server.') }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.contentError {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  &__img {
    width: 65%;
    max-width: 360px;

    @media (min-width: $breakpoint-xl) {
      height: 365px;
      width: 365px;
    }
  }

  &__subtitle {
    @include text-body-1;

    color: rgba(0, 0, 0, 0.38);
    margin-top: 4px;
  }

  &__title {
    color: rgba(0, 0, 0, 0.87);
    font-family: $font-secondary;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;

    @media (min-width: $breakpoint-md) {
      font-size: 36px;
      line-height: 48px;
    }
  }

  &__text {
    @include text-body-1;

    margin-top: 8px;

    @media (min-width: $breakpoint-md) {
      margin-top: 16px;
    }
  }
}
</style>
